// extracted by mini-css-extract-plugin
module.exports = {"Button":"_1GvU__I7mhsIXspP4LSY1H"};